/** @format */

import * as Actions from "../actions/ActionTypes";
const ContactReducer = (
  state = {
    isLoading: false,
    error: undefined,
    status: undefined,
  },
  action
) => {
  switch (action.type) {
    case Actions.CONTACT_US_PENDING:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case Actions.CONTACT_US_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    default:
      return state;
  }
};

export default ContactReducer;
